import { heyreach } from '../../../lib/heyreach'
import type { OutreachStatusData } from '../types'

export type ConnectStepState =
  | 'enable'
  | 'provisioning'
  | 'provisioning-failed'
  | 'awaiting-invitation'
  | 'awaiting-linkedin'
  | 'done'

// Maps the polled outreach status to the connect-flow UI state. Shared by the
// checklist hook (to derive the "LinkedIn connected" condition) and the
// connect dialog, so they always agree.
export function deriveConnectState(status: OutreachStatusData | null): ConnectStepState {
  if (!status || status.status === null) return 'enable'
  switch (status.status) {
    case 'PENDING_SEAT':
      return 'provisioning'
    case 'PENDING_PROVISIONING':
      return status.lastError ? 'provisioning-failed' : 'provisioning'
    case 'AWAITING_SENDER':
      return status.invitationStatus === 'Accepted' ? 'awaiting-linkedin' : 'awaiting-invitation'
    case 'DISCONNECTED':
      // Provider fields cleared; back to the start of setup. Offer connect again.
      return 'enable'
    default:
      return 'done'
  }
}

export function isLinkedInConnected(status: OutreachStatusData | null): boolean {
  return deriveConnectState(status) === 'done'
}

// The external HeyReach URL the founder should land on for a given status, or
// null when there's nothing to open yet (provisioning, done, or the invite is
// still being minted).
export function heyReachHrefForStatus(status: OutreachStatusData | null): string | null {
  switch (deriveConnectState(status)) {
    case 'awaiting-linkedin':
      return heyreach.linkedInAccountsUrl(status?.heyReachWorkspaceId ?? null)
    case 'awaiting-invitation':
      return status?.invitationUrl ?? null
    default:
      return null
  }
}
